import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PhoneInput from "../inputs/phone-input.vue";
import CurrencyInput from "../inputs/currency-input.vue";
import DecimalInput from "../inputs/decimal-input.vue";
import PercentageInput from "../inputs/percentage-input.vue";
import RateInput from "../inputs/rate-input.vue";
import BaseInput from "../inputs/base-input.vue";
import SectionError from "./section-error.vue";
import { getOnlyNumbersReplaceRegex } from "../../utils/utils";
import { trim, isNil } from "lodash";
import MaterialInput from "../inputs/material-input.vue";
import { isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TextSection",
  components: {
    BaseInput,
    RateInput,
    CurrencyInput,
    DecimalInput,
    PhoneInput,
    PercentageInput,
    SectionError,
    MaterialInput
  },
  provide() {
    //mostly needed for address custom section - but can be augmented
    if (this.$validator && this.appendValidatorPath) {
      return {
        $validator: {
          value: this.$validator.value[this.name]
        }
      };
    }
  },
  inject: {
    $validator: {
      default: null
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    decimals: {
      type: Number,
      default: undefined
    },
    name: {
      type: String,
      default: "text"
    },
    type: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    calculated: Boolean,
    autoCalculated: {
      type: Boolean,
      default: true
    },
    calculator: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    containerClass: {
      type: String,
      default: ""
    },
    percentage: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: [String, Number],
      default: null
    },
    max: {
      type: String,
      default: null
    },
    autoFill: {
      type: String,
      default: ""
    },
    autoComplete: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    pattern: {
      type: String,
      default: ""
    },
    patternErrorMessage: {
      type: String,
      default: ""
    },
    allowMinus: {
      type: Boolean,
      default: false
    },
    allowPlus: {
      type: Boolean,
      default: false
    },
    appendValidatorPath: {
      type: Boolean,
      default: false
    },
    showMaxLengthLabel: {
      type: Boolean,
      default: true
    },
    showTooltipMessage: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    labelFor: {
      type: String,
      default: ""
    },
    formattedDecimals: {
      type: Number,
      default: 4
    }
  },
  data() {
    let inputComponent = "base-input";
    const components = {
      phone: "phone-input",
      dollar: "currency-input",
      rate: "rate-input",
      percentage: "percentage-input",
      decimal: "decimal-input"
    };
    for (const key in components) {
      var _context;
      if (_includesInstanceProperty(_context = this.className).call(_context, key)) {
        inputComponent = components[key];
      }
    }
    return {
      inputComponent,
      localValue: this.getValue(this.value),
      labelValue: isEmpty(this.labelFor) ? uuidv4() : this.labelFor,
      patternError: ""
    };
  },
  computed: {
    displayErrorMessage() {
      if (this.errorMessage) return this.errorMessage;
      return this.patternError;
    },
    isNumber() {
      var _context2, _context3;
      return _includesInstanceProperty(_context2 = this.className).call(_context2, "num-field") || _includesInstanceProperty(_context3 = this.className).call(_context3, "fe-num-field");
    },
    isPhoneWithExtension() {
      var _context4;
      return _includesInstanceProperty(_context4 = this.className).call(_context4, "fe-phone-ext");
    },
    calculatedCondition() {
      return this.calculated && this.autoCalculated;
    },
    localVerificationValueLength() {
      var _this$localValue;
      return ((_this$localValue = this.localValue) == null ? void 0 : _this$localValue.length) || 0;
    },
    isTypeEmail() {
      return this.type === "email";
    },
    componentClass() {
      const cssClass = [this.className];
      if (this.calculated) cssClass.push("calculated-field");
      if (this.maxLength && this.showMaxLengthLabel) cssClass.push("max-length-label");
      return cssClass.join(" ");
    }
  },
  watch: {
    value(val) {
      this.localValue = this.getValue(val);
    }
  },
  mounted() {
    var _context5;
    if (_includesInstanceProperty(_context5 = this.className).call(_context5, "company-address")) {
      // load vue autocomplete here
    }
  },
  methods: {
    isPatternValid() {
      if (this.pattern) {
        try {
          const regex = new RegExp(this.pattern);
          if (this.localValue && !regex.test(this.localValue)) {
            this.patternError = this.patternErrorMessage || this.$t("form-validations.validEmail.full");
            return false;
          } else {
            this.patternError = "";
          }
        } catch (e) {
          this.patternError = "";
        }
      }
      return true;
    },
    handleChange(event) {
      const value = this.getValue(event.target.value);
      this.localValue = this.getInputValue(value);
      if (isEmpty(this.pattern) || this.isPatternValid()) this.$emit("change", this.localValue, event);
    },
    handleInput(event) {
      const value = event.target.value;
      this.localValue = this.applyOnTypeValidations(value, event);
    },
    getContainerClass() {
      return `${this.$props.calculated ? "bordered-input  " : ""}${this.calculatedCondition ? "calculated-input " : ""}${this.$props.containerClass} ${this.maxLength ? "floating-validation-container" : ""} ${this.errorMessage ? "error" : ""}`;
    },
    calculate() {
      this.$emit("calculate");
    },
    handleFocusOut(event) {
      if (this.isPatternValid()) this.$emit("focusout", event);
    },
    getInputValue(value) {
      if (value === "") return null;
      if (this.maxLength && !this.isTypeEmail) {
        const decimals = this.inputComponent === "currency-input" ? 2 : this.decimals;
        if (!isNil(decimals)) {
          const [integerPart, decimalPart] = value.split(".", 2);
          const integerFormatted = _sliceInstanceProperty(integerPart).call(integerPart, 0, _parseInt(this.maxLength));
          const parsedDecimals = _parseInt(decimals);
          const decimalFormatted = decimalPart ? `${parsedDecimals > 0 ? "." : ""}${_sliceInstanceProperty(decimalPart).call(decimalPart, 0, parsedDecimals)}` : "";
          return `${integerFormatted}${decimalFormatted}`;
        }
      }
      return this.maxLength ? _sliceInstanceProperty(value).call(value, 0, _parseInt(this.maxLength)) : value;
    },
    applyOnTypeValidations(value, event) {
      let valueAfterValidations = value;
      if (this.isNumber) {
        var _context6, _valueAfterValidation, _valueAfterValidation2;
        const onlyNumbersRegex = getOnlyNumbersReplaceRegex(false, _includesInstanceProperty(_context6 = this.className).call(_context6, "sign"));
        const onlyNumberValue = (_valueAfterValidation = (_valueAfterValidation2 = valueAfterValidations) == null ? void 0 : _replaceAllInstanceProperty(_valueAfterValidation2).call(_valueAfterValidation2, onlyNumbersRegex, "")) != null ? _valueAfterValidation : valueAfterValidations;
        if (onlyNumberValue !== valueAfterValidations) {
          // by the way reactivity works if after removing invalid chars (onlyNumbersValue)
          // and this.localValue and onlyNumbersValue are equal the valu eof the input
          // would remain the same, nothing change in the Vue model.
          // here we force change the value in the input directly to get them back in sync
          event.target.value = onlyNumberValue;
        }
        valueAfterValidations = onlyNumberValue;
      }
      return valueAfterValidations;
    },
    getValue(value) {
      if (!value) return value;
      return trim(this.isTypeEmail ? value.toLowerCase() : value);
    }
  }
});